import React from 'react'
import CoOrdinatorDash from '../../features/coordinator/CoOrdinatorDash'

const CoOrdinatorDashPage = () => {
  return <CoOrdinatorDash/>
}

export default CoOrdinatorDashPage